<template>
	<v-layout
		row
		wrap
		justify-center
	>
		<v-flex xl8>
			<v-data-iterator
				ref="iterator"
				:items="items"
				:pagination.sync="pagination"
				:search="search"
				:rows-per-page-items="rowsPerPageItems"
				:custom-filter="filterItems"
				:custom-sort="customSort"
				:hide-actions="items.length === 0"
				no-data-text="No keyword lists available"
				no-results-text="No matching keyword lists found"
				content-tag="v-layout"
				row
				wrap
				justify-center
			>
				<template v-if="items.length > 0" slot="header">
					<IteratorToolbar
						:sort-by="sortBy"
						:sort-name="sortName"
						:pagination="pagination"
						:initial-view="changeView"
						hide-sort
						hide-change-view
						@search="search = $event"
						@change-view="changeView = $event"
						@sort="sort"
						@pagination="changeSortDirection"
					/>
				</template>
				<v-flex
					slot="item"
					slot-scope="props"
					xs12
				>
					<v-card>
						<v-container>
							<v-layout
								row
								wrap
								align-center
								justify-end
								px-3
							>
								<div class="absolute--right">
									<v-menu
										:disabled="props.item.isDefault"
										bottom
										left
									>
										<v-btn
											v-if="$userCan('manage_keywords') && !project.isArchived"
											slot="activator"
											:disabled="props.item.isDefault"
											small
											icon
											class="ma-2"
										>
											<v-icon>more_vert</v-icon>
										</v-btn>
										<v-list>
											<v-list-tile @click="$emit('default', props.item)">
												<v-list-tile-title>Set Default</v-list-tile-title>
											</v-list-tile>
										</v-list>
									</v-menu>
								</div>
								<div class="headline pb-2">
									{{ props.item.name }}
									<span
										v-if="props.item.isDefault"
										class="subheading"
									>
										(default)
									</span>
								</div>
								<v-spacer/>
								<div v-if="$userCan('manage_keywords') && !project.isArchived">
									<v-btn
										flat
										color="success"
										@click="$emit('add', props.item)"
									>
										Add
									</v-btn>
									<v-btn
										flat
										@click="$emit('update', props.item)"
									>
										Update
									</v-btn>
									<v-btn
										flat
										color="error"
										@click="$emit('delete', props.item)"
									>
										Delete
									</v-btn>
								</div>
							</v-layout>
							<v-layout
								row
								wrap
								justify-center
								align-center
							>
								<template
									v-for="keyword in props.item.keywords"
									pa-0
									class="text-xs-center"
								>
									<v-chip
										:key="keyword.id"
										label
										color="accent darken-2"
										class="white--text"
									>
										<div class="subheading">{{ keyword.keyword }}</div>
										<v-btn
											v-if="$userCan('manage_keywords') && !project.isArchived"
											class="small-btn"
											flat
											icon
											color="error"
											@click="$emit('delete-keyword', keyword, props.item)"
										>
											<v-icon>close</v-icon>
										</v-btn>
									</v-chip>
								</template>
							</v-layout>
						</v-container>
					</v-card>
				</v-flex>
			</v-data-iterator>
		</v-flex>
	</v-layout>
</template>

<script>
import IteratorMixin from '@/mixins/IteratorMixin';
import IteratorToolbar from '@/components/IteratorToolbar';

export default {
	components: {
		IteratorToolbar,
	},
	mixins: [IteratorMixin],
	props: {
		items: { type: Array, default: null },
	},
	data() {
		return {
			pagination: {
				rowsPerPage: 12,
				sortBy: 'name',
				descending: false,
				page: 1,
			},
			fuseOptions: {
				keys: ['name'],
				minMatchCharLength: 2,
				threshold: 0.4,
				shouldSort: true,
			},
		};
	},
	computed: {
		project() {
			return this.$store.get('projects/currentProject');
		},
	},
	methods: {
		customSort(items, index, isDescending) {
			if (index === null) return items;
			if (this.search !== '') {
				return items;
			}
			const sortedItems = items.sort((a, b) => {
				let sortA = (a.justAdded * 2) - 1 || a[index];
				let sortB = (b.justAdded * 2) - 1 || b[index];

				if (isDescending) {
					[sortA, sortB] = [sortB, sortA];
				}

				// Check if both are numbers
				if (!isNaN(sortA) && !isNaN(sortB)) {
					return sortA - sortB;
				}

				// Check if both cannot be evaluated
				if (sortA === null && sortB === null) {
					return 0;
				}

				[sortA, sortB] = [sortA, sortB]
					.map(s => (
						(s || '').toString().toLocaleLowerCase()
					));

				if (sortA > sortB) return 1;
				if (sortA < sortB) return -1;

				return 0;
			});
			const sortedNewItems = [];
			// eslint-disable-next-line
			for (const o of sortedItems) {
				if (o.isDefault) {
					sortedNewItems.unshift(o);
				}
				else {
					sortedNewItems.push(o);
				}
			}
			return sortedNewItems;
		},
	},
};
</script>

<style lang="scss" scoped>
.small-btn {
	margin-top: 0;
	margin-right: -10px;
	margin-bottom: 0;
}
.absolute--right {
	position: absolute;
	top: 0;
	right: 0;
}
</style>
